import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";



const initialState = {
    isLoading: false,
    venteList: [],
    venteDetails: null,
    ventPlat: [],
    ventProduit: [],
    venteSummary: [],
};


export const addVente = createAsyncThunk(
    'vente/addVente',
    async (venteData) => {
        const response = await axios.post(
            `http://localhost:5700/api/admin/vente/addVente`,
            venteData,
            {
                withCredentials: true,
                headers: {
                    "Content-Type": "application/json",
                    "Cache-Control": "no-store, no-cache, must-revalidate, proxy-revalidate",
                },
            },
        );
        return response.data;
    }
);

export const editVente = createAsyncThunk(
    'vente/editVente',
    async ({ id, venteData }) => {
        const response = await axios.put(
            `http://localhost:5700/api/admin/vente/editVente/${id}`,
            venteData,
            {
                withCredentials: true,
                headers: {
                    "Content-Type": "application/json/multipart/form-data",
                    "Cache-Control": "no-store, no-cache, must-revalidate, proxy-revalidate",
                },
            },
        );
        return response.data;
    }
);

export const deleteVente = createAsyncThunk(
    'vente/deleteVente',
    async (venteId) => {
        const response = await axios.delete(
            `http://localhost:5700/api/admin/vente/deleteVente/${venteId}`,
            {
                withCredentials: true,
                headers: {
                    "Content-Type": "application/json",
                    "Cache-Control": "no-store, no-cache, must-revalidate, proxy-revalidate",
                },
            },
        );
        return response.data;
    }
);

export const getVente = createAsyncThunk(
    'vente/getVentes',
    async (id) => {
        const result = await axios.get(
            `http://localhost:5700/api/admin/vente/getVentes/${id}`,
        );

        return result?.data
    }
);

export const getAllVentes = createAsyncThunk(
    'vente/getAllVentes',
    async () => {
        const result = await axios.get(
            `http://localhost:5700/api/admin/vente/getAllVentes`,
        );

        return result?.data
    }
);

export const getPlatVenteSummary = createAsyncThunk(
    'vente/getPlatVenteSummary',
    async () => {
        const result = await axios.get(
            `http://localhost:5700/api/admin/vente/getPlatVenteSummary`,
        );

        return result?.data
    }
);

export const getProduitVenteSummary = createAsyncThunk(
    'vente/getProduitVenteSummary',
    async () => {
        const result = await axios.get(
            `http://localhost:5700/api/admin/vente/getProduitVenteSummary`,
        );

        return result?.data
    }
);

export const getVenteSummary = createAsyncThunk(
    'vente/getVenteSummary',
    async () => {
        const result = await axios.get(
            `http://localhost:5700/api/admin/vente/getVenteSummary`,
        );

        return result?.data
    }
)


export const venteSlice = createSlice({
    name: "vente",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getVente.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getVente.fulfilled, (state, action) => {
                state.isLoading = false;
                state.venteDetails = action.payload.data;
            })
            .addCase(getVente.rejected, (state) => {
                state.isLoading = false;
            })
            .addCase(getAllVentes.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getAllVentes.fulfilled, (state, action) => {
                state.isLoading = false;
                state.venteList = action.payload.data;
            })
            .addCase(getAllVentes.rejected, (state) => {
                state.isLoading = false;
            })
            .addCase(getPlatVenteSummary.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getPlatVenteSummary.fulfilled, (state, action) => {
                state.isLoading = false;
                state.ventPlat = action.payload.data;
            })
            .addCase(getPlatVenteSummary.rejected, (state) => {
                state.isLoading = false;
                state.ventPlat = [];
            })
            .addCase(getProduitVenteSummary.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getProduitVenteSummary.fulfilled, (state, action) => {
                state.isLoading = false;
                state.ventProduit = action.payload.data;
            })
            .addCase(getProduitVenteSummary.rejected, (state) => {
                state.isLoading = false;
                state.ventProduit = [];
            })
            .addCase(getVenteSummary.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getVenteSummary.fulfilled, (state, action) => {
                state.isLoading = false;
                state.venteSummary = action.payload.data;
            })
            .addCase(getVenteSummary.rejected, (state) => {
                state.isLoading = false;
                state.venteSummary = [];
            });
    },
});


export default venteSlice.reducer